import React, { useMemo } from 'react';
import { formatCurrency } from '@sailpoint/bva-core';
import { BENEFIT_VALUE_PROPOSITIONS } from '../libs/types.js';

export default function BenefitTable({ results }) {
    const displayRows = useMemo(() => {
        if (!results || !results.savingsBreakdown) return [];
        const positiveBenefits = results.savingsBreakdown.filter(
            (row) => row.total > 0 && row.benefit !== 'Total'
        );
        const mappedRows = positiveBenefits.map((row) => {
            const benefitKey = row.benefit;
            return {
                benefit: benefitKey,
                valueProposition: BENEFIT_VALUE_PROPOSITIONS[benefitKey] || 'N/A',
                total: row.total
            };
        });
        mappedRows.sort((a, b) => b.total - a.total);
        return mappedRows;
    }, [results]);

    if (!results) return null;
    if (displayRows.length === 0) {
        return (
            <div className="bg-white p-4 rounded-lg shadow mt-8">
                <p className="text-center text-gray-500">
                    No benefit savings to display based on the current inputs.
                </p>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow mt-8">
            <h3 className="text-xl text-gray-700 p-4 text-center">Key Value Drivers</h3>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '20%' }}>Benefit</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '60%' }}>
                                How Does SailPoint add Value
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-widert" style={{ width: '20%' }}>Total</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {displayRows.map((row) => (
                            <tr key={row.benefit}>
                                <td className="px-4 text-left py-3 whitespace-nowrap text-sm text-gray-800 align-top font-medium">{row.benefit}</td>
                                <td className="px-4 text-left py-3 text-sm text-gray-800 align-top">
                                    <ul className="list-disc list-outside pl-5 space-y-1">
                                        {row.valueProposition.split('.').filter(sentence => sentence.trim() !== '').map((sentence, i) => (
                                            <li key={i}>{sentence.trim()}</li>
                                        ))}
                                    </ul>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800 align-top text-right">
                                    <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800">
                                        {formatCurrency(row.total, results.currencySymbol, 'en-US', true)}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
